import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Core version + navigation, pagination modules
import Swiper, { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode ,Controller,EffectFade, EffectCube, EffectCreative, Mousewheel } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-cards';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode,Controller,EffectFade, EffectCube, EffectCreative, Mousewheel]);

// Export for global use if needed
window.Swiper = Swiper

// PURE COUNTER
import PureCounter from "@srexi/purecounterjs";
window.PureCounter = PureCounter

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    const brandSwiper = new Swiper('#brandSwiper', {
        modules: [Autoplay],
        slidesPerView: 4.5,
        spaceBetween: 5,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop:true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        speed: 2000,
        breakpoints: {
            480:{
                slidesPerView: 4.6,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 5.2,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 8.4,
                spaceBetween: 0,
            },
        },
    });



    let problemSwiper = null;

    function initOrDestroySwiper() {
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (isDesktop) {
            // اگر در دسکتاپ هستیم و Swiper فعال است، آن را نابود کن
            if (problemSwiper !== null) {
                problemSwiper.destroy(true, true);
                problemSwiper = null;
            }
        } else {
            // اگر در موبایل هستیم و Swiper فعال نیست، آن را بساز
            if (problemSwiper === null) {
                problemSwiper = new Swiper('#problemSwiper', {
                    modules: [Grid,Pagination],
                    slidesPerView: 1,
                    spaceBetween: 10,
                    observer: true,
                    observeParents: true,
                    on: {
                        slideChange: function () {
                            this.pagination.render();
                            this.pagination.update();
                        },
                    },
                    grid: {
                        rows: 2,
                        fill: 'row'
                    },
                    pagination: {
                        el: '#problemSwiperPagination',
                        clickable: true,
                    },
                    // تنظیمات دیگر ...
                });
            }
        }
    }

// اجرا در زمان لود صفحه
    initOrDestroySwiper();

// اجرا در زمان تغییر سایز مرورگر
    window.addEventListener('resize', initOrDestroySwiper);


    let solutionSwiper = null;
    function initOrDestroySolutionSwiper() {
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (isDesktop) {
            if (solutionSwiper !== null) {
                solutionSwiper.destroy(true, true);
                solutionSwiper = null;
            }
        } else {
            if (solutionSwiper === null) {
                solutionSwiper = new Swiper('#solutionSwiper', {
                    modules: [Pagination, Grid],
                    slidesPerView: 1,
                    spaceBetween: 10,
                    observer: true,
                    observeParents: true,
                    on: {
                        slideChange: function () {
                            this.pagination.render();
                            this.pagination.update();
                        },
                    },
                    grid: {
                        rows: 2,
                        fill: 'row'
                    },
                    pagination: {
                        el: '#solutionSwiperPagination',
                        clickable: true,
                    },
                });
            }
        }
    }
    initOrDestroySolutionSwiper();
    window.addEventListener('resize', initOrDestroySolutionSwiper);


    // const featureSwiper = new Swiper('#featureSwiper', {
    //     modules: [Pagination],
    //     slidesPerView: 1.2,
    //     spaceBetween: 0,
    //     pagination: {
    //         el: '#featureSwiperPagination',
    //         clickable: true,
    //     },
    //     observer: true,
    //     observeParents: true,
    //     on: {
    //         slideChange: function () {
    //             this.pagination.render();
    //             this.pagination.update();
    //         },
    //     },
    //     breakpoints: {
    //         768: {
    //             slidesPerView: 2,
    //         },
    //         1024: {
    //             slidesPerView: 3,
    //             spaceBetween: 1,
    //         },
    //         1280: {
    //             slidesPerView: 4,
    //             spaceBetween: 0,
    //         }
    //     }
    // });

    const featureSwiper = new Swiper('#featureSwiper', {
        modules: [Pagination, Grid],
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        on: {
            slideChange: function () {
                this.pagination.render();
                this.pagination.update();
            },
        },
        grid: {
            rows: 3,
            fill: 'row'
        },
        spaceBetween: 10,
        pagination: {
            el: '#featureSwiperPagination',
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
                enabled: false, // غیرفعال شدن کامل اسلایدر در دسکتاپ
                spaceBetween: 1, // حذف فاصله پیش‌فرض سوییپر تا گرید کار خودش را بکند
            }
        }
    });


    const blogSwiper = new Swiper('#blogSwiper', {
        modules: [Pagination],
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
        observer: true,
        observeParents: true,
        on: {
            slideChange: function () {
                this.pagination.render();
                this.pagination.update();
            },
        },
        breakpoints: {
            480:{
                slidesPerView: 2.5,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 2.8,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        pagination: {
            el: "#blogSwiperPagination",
            clickable: true,
        },
    });

    const heroSwiper = new Swiper("#heroSwiper", {
        modules: [Pagination,Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: "#heroSwiperPagination",
            clickable: true,
        },
    });
};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

